import MuiCard, { CardOwnProps as MuiCardProps } from "@mui/material/Card";
import { lightBlue } from "@mui/material/colors";
import { FC, PropsWithChildren } from "react";

type CardType = "primary" | "secondary" | "error" | "shadow";

const getCardStyles = (type: CardType) => {
  switch (type) {
    case "primary":
      return {
        borderColor: lightBlue[200],
      };
    case "secondary":
      return {
        borderColor: "#E0E0E0",
      };
    case "error":
      return {
        borderColor: "rgba(211, 47, 47, 0.5)",
        backgroundColor: "rgba(211, 47, 47, 0.08)",
      };
    case "shadow":
      return {
        border: "none",
        boxShadow: "0 4px 25px #A6A6A633, 0 1px 1px 0 #F2F2F2",
      };
    default:
      return {};
  }
};

interface ICardProps extends MuiCardProps {
  // have to use type prop because variant is already used
  type: CardType;
}

const Card: FC<PropsWithChildren<ICardProps>> = ({
  type,
  children,
  sx = {},
  ...props
}) => {
  return (
    <MuiCard
      sx={{
        borderRadius: "16px",
        border: "1px solid",
        boxShadow: "none",
        ...sx,
        ...getCardStyles(type),
      }}
      {...props}
    >
      {children}
    </MuiCard>
  );
};

export default Card;
